import { useQuery } from "react-query";
import { useDispatch } from "react-redux";

import { dropdownValuesService } from "services";
import { uiActions } from "store";
import { ErrorResponse } from "types";

const useGetGatewayNamesQuery = () => {
	const dispatch = useDispatch();

	const queryResult = useQuery(
		["gatewayNames"],
		dropdownValuesService.getGateways,
		{
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: error?.title,
					}),
				);
			},
			retry: 0,
			cacheTime: 0,
		},
	);

	return queryResult;
};

export default useGetGatewayNamesQuery;
